import script from "./Username.vue?vue&type=script&setup=true&lang=js"
export * from "./Username.vue?vue&type=script&setup=true&lang=js"

import "./Username.vue?vue&type=style&index=0&id=07b48962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b48962"]])

export default __exports__